<template>
  <div class="s-related-articles-container__wrapper gap-10">
    <div class="s-related-articles-container__wrapper_header">
      <div class="header-item">Related</div>
      <div class="break"></div>
      <div class="header-item">Articles</div>
    </div>
    <div
      v-for="(item, i) of posts"
      :key="i"
      class="s-blog-article-card"
    >
      <div class="s-blog-article-card__header">
        <NuxtLink :to="`/article/${item.slug}`">
          {{ item.title.rendered }}
        </NuxtLink>
      </div>
      <div
        class="s-blog-article-card__text"
        v-html="bigCutText(item.content.rendered)"
      ></div>
      <BlogPageArticleFooter :article="item" />
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      posts: {
        type: Array,
        default: null
      }
    },
    methods: {
      formatDate(date) {
        if (date) {
          return moment(String(date)).format('MM/DD/YYYY')
        }
      },
      bigCutText(item) {
        return item.substring(0, 150) + '...'
      }
    }
  }
</script>

<style scoped lang="postcss">
  .s-blog-article-card {
    border: 2px solid #e5eaed;
    @apply font-alt;
    max-width: 300px;
    @apply p-5 mb-5;
    &__header {
      @apply underline leading-tight block font-semibold;
    }

    &__text {
      color: #7c93a5;
      @apply text-xs mt-2;
    }
  }

  .header-item {
    @apply inline-flex bg-black text-white p-1 px-3 text-left text-xl mb-2;
  }

  .s-related-articles-container {
    @apply font-alt;

    .break {
      flex-basis: 100%;
      height: 0;
    }

    &__articles-wrapper {
      @apply flex flex-row;
    }

    &__wrapper {
      @apply flex flex-row items-start max-w-screen-md mx-auto;
    }
  }
</style>
